import i18n from "../../../language/i18n";
import { useNavigate } from "react-router-dom";
import { SecondaryButton } from "../../../library";
import { useHeroBanner } from "../../../hooks/useHeroBanner";
import { welcomeStyles } from "./WelcomeStyles";

interface WelcomeProps {
  name?: string;
  activeContentList: any[];
  contestDTOList: any[];
  mascotInventoryItemDTOList?: any[];
  dataTour?: string;
}

const Welcome = (props: WelcomeProps) => {
  const { name, activeContentList, contestDTOList, dataTour } = props;
  const navigate = useNavigate();
  const heroBanner = useHeroBanner();

  const retrieveDateLabel = () => {
    const now = new Date();
    const date = now.toLocaleDateString(i18n.language, {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const weekday = now.toLocaleDateString(i18n.language, { weekday: "long" });
    return `${date} · ${weekday}`;
  };

  const renderMessage = () => {
    if (
      activeContentList.filter(
        (activeContent) => activeContent.completionStatus !== "COMPLETED",
      ).length > 0
    ) {
      return i18n.t("you_have_homeworks_to_do_this_week_lets_start");
    } else if (contestDTOList.length !== 2) {
      return i18n.t("you_have_contest_to_complete_this_week_lets_start");
    }
    return i18n.t("you_have_subjects_to_work_on_this_week_lets_start");
  };

  return (
    <div className="qam-root" data-tour={dataTour}>
      <style>{welcomeStyles}</style>
      <div
        className="qam-photo"
        style={
          heroBanner
            ? { backgroundImage: `url("${heroBanner}")`, backgroundPosition: "center" }
            : undefined
        }
      />
      <div className="qam-scrim" />
      <div className="qam-content">
        <div className="qam-date">{retrieveDateLabel()}</div>
        <p className="qam-greeting">
          {i18n.t("hello")} {name}! 👋
        </p>
        <p className="qam-message">{renderMessage()}</p>
        <div className="qam-cta">
          <SecondaryButton
            {...({
              title: i18n.t("lets_start"),
              size: "medium",
              onClick: () => navigate("/homeworks"),
            } as any)}
          />
        </div>
      </div>
    </div>
  );
};

export default Welcome;
